import { createClient } from "@supabase/supabase-js";
import { Database } from "../database.types";

export const supabaseClient = createClient<Database>(
  import.meta.env.VITE_SUPABASE_URL as string,
  import.meta.env.VITE_SUPABASE_API_KEY as string
);
